<template>
    
</template>

<script>
// import bimToast from '@bimlib/components/bimToast'

export default {
  data() {
    return {
    }
  },
  mounted () {
    this.checkIfShowed();
  },
  methods: {
		checkIfShowed() {
      if(localStorage.getItem('_user_language_') === 'en') {
        if (localStorage.getItem('langToastShowed')) {
          return;
        } else {
          this.$toast('We are currently in the process of localizing content to the English. We apologize for any inconvenience caused.', { title: 'Attention' });
          localStorage.setItem('langToastShowed', 'true')
        }
      }
		}
  }
};
</script>

<style lang="scss" scoped>
@import './src/front_white/sass/components/color';

</style>